import React from "react";

const HeroSection = () => {
  return (
    <section className="lg:py-16 py-4">
      <div className="container mx-auto flex flex-col md:flex-row items-center">
        <div className="md:w-1/2 p-4">
          <h1 className="text-4xl font-bold mb-4">
            Leading the Way in Denim Craftsmanship
          </h1>
          <p className="text-lg mb-6">
            At Pawan Kaaz, we are pioneers in providing top-tier services for
            the denim industry. From our precision <span style={{color: "blue", fontWeight: "bold"}}>KAAZ BUTTON'</span>{" "}
            solutions to expert stitching and meticulous finishing, we ensure
            your jeans are crafted to perfection. As the first to implement CCTV
            in all our factories, we guarantee accuracy and transparency.
            Trusted by leading manufacturers for over 15 years, we operate the
            largest facilities dedicated to each stage of production, ensuring
            unmatched quality and efficiency.
          </p>
          <button className="bg-black text-white px-4 py-2 rounded">
            Explore Our Services
          </button>
        </div>
        <div className="md:w-1/2 p-4">
          <img
            src="https://imgs.search.brave.com/xG4X0d6SyGRpwELBa2xNQnCRGomtkWvKHELkTuclUxI/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9pMC53/cC5jb20vd3d3LnRo/ZWxhc3RzdGl0Y2gu/Y29tL3dwLWNvbnRl/bnQvdXBsb2Fkcy9z/ZXdpbmctYnV0dG9u/aG9sZXMtYW5kLWJ1/dHRvbnMtb24tamVh/bnMtdHV0b3JpYWwt/Ni5qcGc_cmVzaXpl/PTEwMjQsNjY4JnNz/bD0x"
            alt="Hero"
            className="w-full h-auto rounded shadow-md"
          />
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
